<template>
  <div :class="['b-radio-group']">
    <span
      class="b-radio"
      :class="[{ active: value === radio.value }]"
      v-for="radio in list"
      :key="radio.value"
      @click="handleClick(radio)"
    >
      {{radio.name}}
    </span>
  </div>
</template>

<script>
export default {
  name: 'RadioGroup',
  props: {
    value: {
      type: String,
    },
    list: {
      type: Array,
      isRequired: true,
    },
  },
  methods: {
    handleClick(radio) {
      this.$emit('input', radio.value);
      this.$emit('change', radio.value);
    },
  },
};
</script>

<style lang="scss" scoped>
  .b-radio {
    min-width: 48px;
    display: inline-block;
    height: 24px;
    line-height: 24px;
    padding: 0 5px;
    cursor: pointer;
    background-color: #F5F5F9;
    color: #333333;
    font-size: 12px;
    margin-top: -1px;
    margin-left: -1px;
    border-radius: 4px;
    margin-right: 5px;
    &.active {
      background-color: #77A3FF;
      color: #ffffff;
    }
  }

  .b-radio-group {
    display: inline-block;
    .b-radio {
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
</style>
